const CookieReader = require('@vp/cookie-consent-client-reader');

function getCategoryPreferences() {
    return CookieReader.getCategoryPreferences();
}
module.exports = { getCategoryPreferences };
